import { fromJS } from 'immutable';

import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GetChatHistory } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (msisdn) => async (dispatch, getState) => {
    
    const Authorization = UserToken;
    const url = ApiUrl2 + '/helpdesk-gettickethistory';
    
    let formdata = new FormData();
    formdata.append("msisdn",msisdn)
    const argument = {  
        method: 'POST',
        headers : {
            'Authorization': Authorization,
        },
        body: formdata,
    };  

    const response = await doFetch(url,argument);
    var data = fromJS({});
    
    if(response.ok){
        data = fromJS(await response.json());
        data = fromJS(data.get('data'));
    }

    dispatch({ type: GetChatHistory, data: data });
};